import { AxiosResponse } from 'axios'
import hosts from 'config/microServices'
import IUsuarioChat from 'Models/chat/IUsuarioChat'
import ApiService from 'Services/ApiService'
import { ServiceListResponse } from 'Types/ServiceResponse'

const usuarios = {
  getUsuario: async () => {
    const result: AxiosResponse<ServiceListResponse<IUsuarioChat>> =
      await ApiService().get<ServiceListResponse<IUsuarioChat>>(
        `${hosts.WS_CHAT}/usuario`,
      )

    return result
  },
}

export default usuarios
